// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./compositionApi";
import "@/api/init-op-utils-self-axios";

import Vue from 'vue'
import store from '@/store'
import router from '@/router'

import 'font-awesome-webpack'
//引入UI组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import '@/assets/theme/index.css';
//引入iconfont图标
import '@/assets/icon/icon.css'

Vue.use(ElementUI)
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)
    //引入sass生产的css
import '@/assets/css/style.css'
//引入全局过滤器
import '@/util/filter'

//公共样式引入
import '../static/css/common.css'
import "@/util/statistics.js"

import {
  initUserSelectedDialog,
} from "@oppein/op-web-components";
initUserSelectedDialog("op-web-user-selected-dialog");

// // 引入jquery
// import $ from 'jquery'

Vue.config.productionTip = false

const whiteList = ['/resources/404', '/resources/test'] // 不重定向白名单
router.beforeEach((to, from, next) => {


    // 这种情况下直接通过这个路由 不进行登录判断
    if (to.query.accessType === 'single') {
        if (to.name) {
            next()
        } else {
            store.dispatch('whiteRoutes', to).then(() => { // 生成可访问的路由表
                router.options.routes = store.getters.routers
                router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                next({...to })
            })
        }
    } else {
        //可以加进度条
        //进度条 start
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            let user = store.getters.user
            if (user) {
                next()
            } else {
                store.dispatch('GetInfo').then(res => { // 验证用户是否登录并获取用户登录信息
                    if (res.status) {
                        if(res.data&&(res.data.globalId||res.data.mtdsUserId)&&process.env.VUE_APP_COLLECT_URL){
                            window.opCollect.setMtdsId(res.data.mtdsUserId||res.data.globalId); // B端用户id
                            window.opCollect.init({
                              appCode: "BILL", // appCode
                              subAppCode: "BILLPC001", // subAppCode
                              eventType: ["click"], // pc用click，移动端用touchend
                            });
                        }
                        next({...to })

                        // /account-order/menu接口相关内容，已无用先注掉观察
                        // store.dispatch('GetRouters').then(res => {
                        //     const roles = res.data
                        //     store.dispatch('GenerateRoutes', roles).then(() => { // 生成可访问的路由表
                        //         router.options.routes = store.getters.routers
                        //         router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                        //         next({...to })
                        //     })
                        // })
                    } else {
                        console.log('用户未登录')
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
})

router.afterEach(() => {
    //进度条 end
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    //    $,
    template: '<router-view :key="key"></router-view>',
    computed: {
        key() {
            return this.$router.name !== undefined ? this.$router.name + +new Date() : this.$router + +new Date()
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js